import * as React from 'react';
import axios from 'axios';
import config from '../../config';
import { IMedia } from '../../interfaces';
import { NavLink } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import i18n from '../../config/i18next';

interface IState {
    isLoading: boolean,
    slides: IMedia[],
    isUnmounted: boolean
}

class Carousel extends React.Component<any, IState>{
    public state: IState = {
        isLoading: true,
        slides: [],
        isUnmounted: false,
    }

    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    async componentDidMount() {
        try {
            let { data } = await axios.get(`${config.site}/${i18n.language}/api/film/banner`);

            if (this._isUnmounted) return;

            this.setState({
                slides: data,
                isLoading: false
            }, () => {
                $('#carusel1').owlCarousel({
                    loop: true,
                    margin: 10,
                    nav: true,
                    autoplay: true,
                    autoplayTimeout: 8000,
                    autoHeight: true,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 1
                        },
                        1000: {
                            items: 1
                        }
                    }
                });
                $(window).ready(function () {
                    setTimeout(function () {
                        $('.owl-carousel').trigger('refresh.owl.carousel');
                    }, 50);
                });
            });

        } catch (e) {

        }


    }

    render() {
        const { t } = this.props;

        return (
            <div>
                {this.state.isLoading && <div className="carousel-placeholder"></div>}
                <div className="owl-carousel" id="carusel1">
                    {this.state.slides.map((slide: IMedia, index: number) => {
                        return (
                            <div className="item" key={index}>
                                <div className="Box">
                                    <img src={slide.fullSlideImage} />
                                </div>
                                <div className="Caption">
                                    <div className="left">
                                        <span> {slide.age.toString().replace("+", "")}+ </span>
                                    </div>
                                    <div className="right">
                                        <NavLink to={`/film/${slide.url ? slide.url : 'view'}/${slide.media_id}`}>
                                            <i className="fa fa-play"></i>
                                            {t("Смотреть онлайн")}
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        );
                    })}

                </div>
            </div>

        );
    }
}

export default withTranslation()(Carousel);